import { createContext, useContext, useState, useCallback } from "react";

const LocationContext = createContext();
export const LocationProvider = ({ children }) => {
  const [location, setLocation] = useState({ lat: null, lon: null });

  const fetchLocation = useCallback(() => {
    return new Promise(async (resolve, reject) => {
      if (!navigator.geolocation) {
        reject("Geolocation not supported");
        return;
      }

      if (navigator.permissions) {
        try {
          const status = await navigator.permissions.query({
            name: "geolocation",
          });
          if (status.state === "denied") {
            alert(
              "Location access is blocked for this site.\n\n" +
                "To enable it:\n" +
                "1. Click the lock icon in the address bar.\n" +
                "2. Reset or allow Location permission.\n" +
                "3. Refresh the page."
            );
            return resolve(null);
          }
        } catch (err) {
          console.warn("Permissions API check failed:", err);
        }
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          const coords = {
            lat: position.coords.latitude,
            lon: position.coords.longitude,
          };
          setLocation(coords);
          resolve(coords);
        },
        (err) => {
          setLocation({ lat: null, lon: null });
          reject(err);
        }
      );
    });
  }, []);

  return (
    <LocationContext.Provider value={{ ...location, fetchLocation }}>
      {children}
    </LocationContext.Provider>
  );
};
export const useCurrentLocation = () => useContext(LocationContext);
